import { apiClient } from '@/http/apiClient';
import { buildQuery, joinUrl } from '@/http/url';
import { AxiosPromise } from 'axios';
const rootPath = 'Translations';

class TranslationService {
  
    public async getTranslations(params: { bopModelKey: string }): Promise<any> {
        return apiClient.get(`${rootPath}${buildQuery({ bopModelKey: params.bopModelKey })}`);
    }

    public getTranslationsUrl(params: any): string {
        return joinUrl(apiClient.defaults.baseURL || '', rootPath) + buildQuery({ ...params });
    }

    public save(data: any): AxiosPromise {
        return apiClient.put(`${rootPath}/${data.id}`, data);
    }
    
}

export default new TranslationService();